import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/ponds')({
  component: PondsLayout,
});

/**
 * Layout route for /ponds/*
 * - /ponds → renders ponds.index.tsx (grid view)
 * - /ponds/$pondId → renders ponds.$pondId.tsx (detail view)
 */
function PondsLayout() {
  return <Outlet />;
}
